"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (fn, wait, immediate) {
    if (wait === void 0) { wait = 0; }
    if (immediate === void 0) { immediate = false; }
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ctx = this;
        clearTimeout(timeout);
        var callNow = immediate && !timeout;
        timeout = setTimeout(function () {
            timeout = null;
            return !immediate && fn.apply(ctx, args);
        }, wait);
        return callNow && fn.apply(ctx, args);
    };
});
//# sourceMappingURL=debounce.js.map